import React from 'react';
import PropTypes from 'prop-types';
import RelativePopout from '../../../../../components/RelativePopout';
import ProjectTemplateAdd from '../../../../../components/ProjectTemplateAdd';

const AddTemplateView = ({
  addingTemplate,
  parentRef,
  handleCloseAddCard,
  project_type,
  closeoutTemplates,
  selectedCompany,
  markets,
  handleAddProjectTemplate,
  addTemplateRef,
}) => {
  if (!addingTemplate) {
    return null;
  }

  let rect = null;
  let verticalOffset = 0;
  let verticalOffsetFudge = 90;
  
  if (parentRef.current) {
    rect = parentRef.current.getBoundingClientRect();
    if (rect.top + 250 > window.innerHeight) {
      verticalOffset = rect.top - (window.innerHeight - 250);
    }
  }

  return (
    <div ref={addTemplateRef}>
      <RelativePopout
        top={rect ? rect.top - (verticalOffset + verticalOffsetFudge) + 143 : 0}
        left={rect ? rect.width - 15 : 0}
        verticalOffset={verticalOffset}
      >
        <ProjectTemplateAdd
          id="project-template-add-card"
          closeoutTemplates={closeoutTemplates}
          closeAddCard={handleCloseAddCard}
          selectedProjectType={project_type}
          selectedCompany={selectedCompany}
          markets={markets}
          existingTemplates={project_type.project_templates}
          version="1"
          handleAddProjectTemplate={handleAddProjectTemplate}
        />
      </RelativePopout>
    </div>
  );
};

AddTemplateView.propTypes = {
  addingTemplate: PropTypes.bool.isRequired,
  parentRef: PropTypes.object.isRequired,
  handleCloseAddCard: PropTypes.func.isRequired,
  project_type: PropTypes.object.isRequired,
  closeoutTemplates: PropTypes.array,
  selectedCompany: PropTypes.object,
  markets: PropTypes.array,
  handleAddProjectTemplate: PropTypes.func.isRequired,
  addTemplateRef: PropTypes.object,
};

export default AddTemplateView;



// WEBPACK FOOTER //
// ./src/containers/ProjectTemplatesContainer/ProjectTypesNav/ProjectTypeNavCard/components/AddTemplateView.js